import { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Shell from './components/layout/Shell'
import { useAuth } from './lib/auth'

// Auth
import LoginPage from './routes/LoginPage'

// Pages
import DashboardPage from './routes/DashboardPage'
import TechNewsPage from './routes/TechNewsPage'
import CyberPage from './routes/CyberPage'
import CloudPage from './routes/CloudPage'
import InnovationPage from './routes/InnovationPage'
import SignalsPage from './routes/SignalsPage'
import AIAdoptionPage from './routes/AIAdoptionPage'
import AIRiskLivePage from './routes/AIRiskLivePage'
import RegulatoryPage from './routes/RegulatoryPage'
import StartupsPage from './routes/StartupsPage'
import InternetHealthPage from './routes/InternetHealthPage'
import SupplyChainPage from './routes/SupplyChainPage'
import OpenSourcePage from './routes/OpenSourcePage'
import TalentPage from './routes/TalentPage'
import TrendsPage from './routes/TrendsPage'
import HypeCyclePage from './routes/HypeCyclePage'
import BriefingPage from './routes/BriefingPage'
import CompetitorIntelPage from './routes/CompetitorIntelPage'
import MandAPage from './routes/MandAPage'
import EnergyPage from './routes/EnergyPage'
import SentimentPage from './routes/SentimentPage'
import IncidentPage from './routes/IncidentPage'
import GlobeTestPage from './routes/GlobeTestPage'
import TerminalPage from './routes/TerminalPage'
import IntegrationsPage from './routes/IntegrationsPage'
import CyberWarRoomPage from './routes/CyberWarRoomPage'
import TrendChartsPage from './routes/TrendChartsPage'
import WatchlistPage from './routes/WatchlistPage'
import AdminPage from './routes/AdminPage'
import CloudPricingPage from './routes/CloudPricingPage'
import PricingTrendsPage from './routes/PricingTrendsPage'
import FeedManagerPage from './routes/FeedManagerPage'
import AdminFeedsPage from './routes/AdminFeedsPage'
import WikiPage from './routes/WikiPage'
import ApiDocsPage from './routes/ApiDocsPage'
import SettingsPage from './routes/SettingsPage'
import ActivityLogPage from './routes/ActivityLogPage'
import ForYouPage from './routes/ForYouPage'
import TechRadarPage from './routes/TechRadarPage'
import AIInsightsPage from './routes/AIInsightsPage'
import BookmarksPage from './routes/BookmarksPage'
import NotesPage from './routes/NotesPage'
import WhatChangedPage from './routes/WhatChangedPage'
import VendorComparisonPage from './routes/VendorComparisonPage'
import OutageHistoryPage from './routes/OutageHistoryPage'
import TopStoriesPage from './routes/TopStoriesPage'
import CompliancePage from './routes/CompliancePage'
import EarningsCalendarPage from './routes/EarningsCalendarPage'
import SentimentTrackingPage from './routes/SentimentTrackingPage'
import WorkspacePage from './routes/WorkspacePage'
import AIModelsPage from './routes/AIModelsPage'
import AICostCalculatorPage from './routes/AICostCalculatorPage'
import EOLCalendarPage from './routes/EOLCalendarPage'
import EOLManagePage from './routes/EOLManagePage'
import ExecutiveSummaryPage from './routes/ExecutiveSummaryPage'
import ConnectorsManagePage from './routes/ConnectorsManagePage'
import ConnectorHealthPage from './routes/ConnectorHealthPage'
import RansomwarePage from './routes/RansomwarePage'
import SuperTrendsPage from './routes/SuperTrendsPage'
import ExposurePage from './routes/ExposurePage'
import HelpPage from './routes/HelpPage'
import ThreatActorsPage from './routes/ThreatActorsPage'
import CyberNewsPage from './routes/CyberNewsPage'
import ChangelogPage from './routes/ChangelogPage'
import ThreatGlobePage from './routes/ThreatGlobePage'
import AgentsConsolePage from './routes/AgentsConsolePage'
import CveDetailPage from './routes/CveDetailPage'
import RiskMatrixPage from './routes/RiskMatrixPage'
import ServiceCatalogPage from './routes/ServiceCatalogPage'
import BlueprintsPage from './routes/BlueprintsPage'
import EntitiesPage from './routes/EntitiesPage'
import ScorecardsPage from './routes/ScorecardsPage'
import ActionsPage from './routes/ActionsPage'
import DesignerPage from './routes/DesignerPage'
import AgentRunsPage from './routes/AgentRunsPage'
import ZeroDayClockPage from './routes/ZeroDayClockPage'
import SavingsPage from './routes/SavingsPage'
import NavVisibilityPage from './routes/NavVisibilityPage'
import CredentialsPage from './routes/CredentialsPage'
import FrontierModelsPage from './routes/FrontierModelsPage'
import FrontierGlobePage from './routes/FrontierGlobePage'
import FrontierDefencePage from './routes/FrontierDefencePage'
import VigilancePage from './routes/VigilancePage'
import AIIncidentsPage from './routes/AIIncidentsPage'
import FrontierRegulationPage from './routes/FrontierRegulationPage'
import ModelReleasesPage from './routes/ModelReleasesPage'
import NotableModelsPage from './routes/NotableModelsPage'
import IndustryWatchPage from './routes/IndustryWatchPage'
import TrendingPapersPage from './routes/TrendingPapersPage'
import BenchmarksPage from './routes/BenchmarksPage'
import NationalStrategiesPage from './routes/NationalStrategiesPage'
import ArxivFirehosePage from './routes/ArxivFirehosePage'
import KnowledgeBasePage from './routes/KnowledgeBasePage'
import FrontierIndexPage from './routes/FrontierIndexPage'
import FrontierTimelinePage from './routes/FrontierTimelinePage'
import FrontierEditorPage from './routes/FrontierEditorPage'
import FrontierRankingsPage from './routes/FrontierRankingsPage'
import PricingPage from './routes/PricingPage'
import CdmPage from './routes/CdmPage'
import CdmGroupSocPage from './routes/CdmGroupSocPage'
import CdmInvestigationPage from './routes/CdmInvestigationPage'
import CdmPolicyProposalsPage from './routes/CdmPolicyProposalsPage'
import CdmUsersPage from './routes/CdmUsersPage'
import CdmSoftwarePage from './routes/CdmSoftwarePage'
import CdmNetworkPage from './routes/CdmNetworkPage'
import CdmAdaptersPage from './routes/CdmAdaptersPage'
import CdmCompliancePage from './routes/CdmCompliancePage'
import CdmNHIsPage from './routes/CdmNHIsPage'
import CdmReportPage from './routes/CdmReportPage'
import CdmSpecsPage from './routes/CdmSpecsPage'
import CdmImportPage from './routes/CdmImportPage'
import CdmWebhooksPage from './routes/CdmWebhooksPage'
import CdmRemediationPage from './routes/CdmRemediationPage'
import CdmRegulationTimersPage from './routes/CdmRegulationTimersPage'
import CdmAttributionLensPage from './routes/CdmAttributionLensPage'
import CdmFrontierOverlayPage from './routes/CdmFrontierOverlayPage'
import CdmCorrelationsPage from './routes/CdmCorrelationsPage'
import CdmCorrelationRulesPage from './routes/CdmCorrelationRulesPage'
import CdmConnectivityPage from './routes/CdmConnectivityPage'
import CdmShadowSaasPage from './routes/CdmShadowSaasPage'
import CdmDashboardsPage from './routes/CdmDashboardsPage'
import CdmSavedQueriesPage from './routes/CdmSavedQueriesPage'
import CdmEnforcementPage from './routes/CdmEnforcementPage'
import CdmChangePipelinePage from './routes/CdmChangePipelinePage'
import CdmGitopsPage from './routes/CdmGitopsPage'
import CdmReplayPage from './routes/CdmReplayPage'
import CdmPrivacyPage from './routes/CdmPrivacyPage'
import AttackPathsPage from './routes/AttackPathsPage'
import AIVulnDiscoveryPage from './routes/AIVulnDiscoveryPage'
import ExploitationRacePage from './routes/ExploitationRacePage'
import TargetStatePage from './routes/TargetStatePage'
import PurpleRangePage from './routes/PurpleRangePage'
import NextBestActionPage from './routes/NextBestActionPage'
import ExecNarrativePage from './routes/ExecNarrativePage'
import UnderwritingPage from './routes/UnderwritingPage'
import AdminUnderwritingPricingPage from './routes/AdminUnderwritingPricingPage'
import AdminAccessPage from './routes/AdminAccessPage'
import AdminJmlPage from './routes/AdminJmlPage'
import AdminOrgsPage from './routes/AdminOrgsPage'
import AdminSystemHealthPage from './routes/AdminSystemHealthPage'
import MyAccessPage from './routes/MyAccessPage'
import CountdownBoardPage from './routes/CountdownBoardPage'
import PostmortemsPage from './routes/PostmortemsPage'
import ServiceGraphPage from './routes/ServiceGraphPage'
import DecisionsPage from './routes/DecisionsPage'
import WeeklyDiffPage from './routes/WeeklyDiffPage'
import TimeMachinePage from './routes/TimeMachinePage'
import LeaversPage from './routes/LeaversPage'
import SbomPage from './routes/SbomPage'
import AttackMatrixPage from './routes/AttackMatrixPage'
import VulnTriagePage from './routes/VulnTriagePage'
import StatusPagePublic from './routes/StatusPagePublic'
import BrandMentionsPage from './routes/BrandMentionsPage'
import SigmaRulesPage from './routes/SigmaRulesPage'
import DnsPosturePage from './routes/DnsPosturePage'
import CompliancePosturePage from './routes/CompliancePosturePage'
import DepConfusionPage from './routes/DepConfusionPage'
import OsvFeedPage from './routes/OsvFeedPage'
import IpReputationPage from './routes/IpReputationPage'
import ShodanQueriesPage from './routes/ShodanQueriesPage'
import DoraMetricsPage from './routes/DoraMetricsPage'
import SupplyChainTrustPage from './routes/SupplyChainTrustPage'
import DetectionCoveragePage from './routes/DetectionCoveragePage'
import AtomicRedTeamPage from './routes/AtomicRedTeamPage'
import CanaryTokenPage from './routes/CanaryTokenPage'
import NsmLensPage from './routes/NsmLensPage'
import MispGalaxyPage from './routes/MispGalaxyPage'
import SloPage from './routes/SloPage'
import ChaosPage from './routes/ChaosPage'
import DriftPage from './routes/DriftPage'
import PolicyPage from './routes/PolicyPage'
import IdpRiskyPage from './routes/IdpRiskyPage'
import SecretScansPage from './routes/SecretScansPage'
import RunbooksPage from './routes/RunbooksPage'
import TabletopPage from './routes/TabletopPage'
import BcpPage from './routes/BcpPage'
import ServiceReadmePage from './routes/ServiceReadmePage'
import DataResidencyPage from './routes/DataResidencyPage'
import RansomwareGeoPage from './routes/RansomwareGeoPage'
import RansomwareCountryDetailPage from './routes/RansomwareCountryDetailPage'
import OnCallPage from './routes/OnCallPage'
import GhReleasesPage from './routes/GhReleasesPage'
import AskPage from './routes/AskPage'
import CiStatusPage from './routes/CiStatusPage'
import ActorDetailPage from './routes/ActorDetailPage'
import PatchTuesdayPage from './routes/PatchTuesdayPage'
import VendorRiskPage from './routes/VendorRiskPage'
import CredentialExpiryPage from './routes/CredentialExpiryPage'
import PersonaChooserPage from './routes/PersonaChooserPage'
import CtoLandingPage from './routes/CtoLandingPage'
import CioLandingPage from './routes/CioLandingPage'
import CisoLandingPage from './routes/CisoLandingPage'
import ComplianceLandingPage from './routes/ComplianceLandingPage'
import SocLandingPage from './routes/SocLandingPage'
import SdlcLandingPage from './routes/SdlcLandingPage'
import HostingLandingPage from './routes/HostingLandingPage'
import HelpdeskLandingPage from './routes/HelpdeskLandingPage'
import DevopsLandingPage from './routes/DevopsLandingPage'

const WorldEventsPage = lazy(() => import('./routes/WorldEventsPage'))

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-text-muted text-sm">Loading...</div>
    </div>
  )
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  const { checkAuth } = useAuth()
  useEffect(() => { checkAuth() }, [checkAuth])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/app" element={<ProtectedRoute><Shell /></ProtectedRoute>}>
          <Route index element={<DashboardPage />} />
          <Route path="landing"            element={<PersonaChooserPage />} />
          <Route path="landing/cto"        element={<CtoLandingPage />} />
          <Route path="landing/cio"        element={<CioLandingPage />} />
          <Route path="landing/ciso"       element={<CisoLandingPage />} />
          <Route path="landing/compliance" element={<ComplianceLandingPage />} />
          <Route path="landing/soc"        element={<SocLandingPage />} />
          <Route path="landing/sdlc"       element={<SdlcLandingPage />} />
          <Route path="landing/hosting"    element={<HostingLandingPage />} />
          <Route path="landing/helpdesk"   element={<HelpdeskLandingPage />} />
          <Route path="landing/devops"     element={<DevopsLandingPage />} />
          <Route path="signals" element={<SignalsPage />} />
          <Route path="super-trends" element={<SuperTrendsPage />} />
          <Route path="trends" element={<Navigate to="/app/super-trends" replace />} />
          <Route path="tech-news" element={<TechNewsPage />} />
          <Route path="cyber" element={<CyberPage />} />
          <Route path="cyber-warroom" element={<CyberWarRoomPage />} />
          <Route path="trend-charts" element={<Navigate to="/app/super-trends?view=timeline" replace />} />
          <Route path="watchlist" element={<WatchlistPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="blueprints" element={<BlueprintsPage />} />
          <Route path="entities/:blueprintId" element={<EntitiesPage />} />
          <Route path="scorecards" element={<ScorecardsPage />} />
          <Route path="actions" element={<ActionsPage />} />
          <Route path="designer" element={<DesignerPage />} />
          <Route path="agent-runs" element={<AgentRunsPage />} />
          <Route path="pricing" element={<CloudPricingPage />} />
          <Route path="pricing-trends" element={<PricingTrendsPage />} />
          <Route path="feed-manager" element={<FeedManagerPage />} />
          <Route path="admin/feeds" element={<AdminFeedsPage />} />
          <Route path="wiki" element={<WikiPage />} />
          <Route path="api-docs" element={<ApiDocsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="activity" element={<ActivityLogPage />} />
          <Route path="for-you" element={<ForYouPage />} />
          <Route path="tech-radar" element={<TechRadarPage />} />
          <Route path="ai-insights" element={<AIInsightsPage />} />
          <Route path="ai-models" element={<AIModelsPage />} />
          <Route path="ai-costs" element={<AICostCalculatorPage />} />
          <Route path="eol" element={<EOLCalendarPage />} />
          <Route path="eol-manage" element={<EOLManagePage />} />
          <Route path="executive" element={<ExecutiveSummaryPage />} />
          <Route path="connectors-manage" element={<ConnectorsManagePage />} />
          <Route path="connectors-health" element={<ConnectorHealthPage />} />
          <Route path="ransomware" element={<RansomwarePage />} />
          <Route path="exposure" element={<ExposurePage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="threat-actors" element={<ThreatActorsPage />} />
          <Route path="cyber-news" element={<CyberNewsPage />} />
          <Route path="changelog" element={<ChangelogPage />} />
          <Route path="threat-globe"   element={<ThreatGlobePage title="Threat Globe" modeKey="mode" />} />
          <Route path="war-room-globe" element={<ThreatGlobePage title="Situation-Room Globe" modeKey="wmode" lobby />} />
          <Route path="threat-map"     element={<Navigate to="/app/threat-globe?mode=2d" replace />} />
          <Route path="agents" element={<AgentsConsolePage />} />
          <Route path="cve/:id" element={<CveDetailPage />} />
          <Route path="risk-matrix" element={<RiskMatrixPage />} />
          <Route path="services" element={<ServiceCatalogPage />} />
          <Route path="zero-day-clock" element={<ZeroDayClockPage />} />
          <Route path="savings" element={<SavingsPage />} />
          <Route path="admin/nav-visibility" element={<NavVisibilityPage />} />
          <Route path="admin/credentials" element={<CredentialsPage />} />
          <Route path="admin/access" element={<AdminAccessPage />} />
          <Route path="admin/jml" element={<AdminJmlPage />} />
          <Route path="admin/orgs" element={<AdminOrgsPage />} />
          <Route path="admin/system-health" element={<AdminSystemHealthPage />} />
          <Route path="me/access" element={<MyAccessPage />} />
          <Route path="frontier-models" element={<FrontierModelsPage />} />
          <Route path="frontier-globe" element={<FrontierGlobePage />} />
          <Route path="frontier-defence" element={<FrontierDefencePage />} />
          <Route path="vigilance" element={<VigilancePage />} />
          <Route path="ai-incidents" element={<AIIncidentsPage />} />
          <Route path="frontier-regulation" element={<FrontierRegulationPage />} />
          <Route path="model-releases" element={<ModelReleasesPage />} />
          <Route path="notable-models" element={<NotableModelsPage />} />
          <Route path="industry-watch" element={<IndustryWatchPage />} />
          <Route path="trending-papers" element={<TrendingPapersPage />} />
          <Route path="benchmarks" element={<BenchmarksPage />} />
          <Route path="national-strategies" element={<NationalStrategiesPage />} />
          <Route path="arxiv" element={<ArxivFirehosePage />} />
          <Route path="knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="frontier-index" element={<FrontierIndexPage />} />
          <Route path="frontier-timeline" element={<FrontierTimelinePage />} />
          <Route path="frontier-editor" element={<FrontierEditorPage />} />
          <Route path="frontier-rankings" element={<FrontierRankingsPage />} />
          <Route path="frontier-pricing" element={<PricingPage />} />
          <Route path="cdm" element={<CdmPage />} />
          <Route path="cdm/group-soc" element={<CdmGroupSocPage />} />
          <Route path="cdm/investigation/:id" element={<CdmInvestigationPage />} />
          <Route path="cdm/policy-proposals" element={<CdmPolicyProposalsPage />} />
          <Route path="cdm/users" element={<CdmUsersPage />} />
          <Route path="cdm/software" element={<CdmSoftwarePage />} />
          <Route path="cdm/network" element={<CdmNetworkPage />} />
          <Route path="cdm/adapters" element={<CdmAdaptersPage />} />
          <Route path="cdm/compliance" element={<CdmCompliancePage />} />
          <Route path="cdm/nhis" element={<CdmNHIsPage />} />
          <Route path="cdm/report" element={<CdmReportPage />} />
          <Route path="cdm/specs" element={<CdmSpecsPage />} />
          <Route path="cdm/import" element={<CdmImportPage />} />
          <Route path="cdm/webhooks" element={<CdmWebhooksPage />} />
          <Route path="cdm/remediation" element={<CdmRemediationPage />} />
          <Route path="cdm/regulation-timers" element={<CdmRegulationTimersPage />} />
          <Route path="cdm/attribution" element={<CdmAttributionLensPage />} />
          <Route path="cdm/frontier-overlay" element={<CdmFrontierOverlayPage />} />
          <Route path="cdm/correlations" element={<CdmCorrelationsPage />} />
          <Route path="cdm/correlation-rules" element={<CdmCorrelationRulesPage />} />
          <Route path="cdm/connectivity" element={<CdmConnectivityPage />} />
          <Route path="cdm/shadow-saas" element={<CdmShadowSaasPage />} />
          <Route path="cdm/dashboards" element={<CdmDashboardsPage />} />
          <Route path="cdm/queries" element={<CdmSavedQueriesPage />} />
          <Route path="cdm/enforcement" element={<CdmEnforcementPage />} />
          <Route path="cdm/changes" element={<CdmChangePipelinePage />} />
          <Route path="cdm/gitops" element={<CdmGitopsPage />} />
          <Route path="cdm/replay" element={<CdmReplayPage />} />
          <Route path="cdm/privacy" element={<CdmPrivacyPage />} />
          <Route path="attack-paths" element={<AttackPathsPage />} />
          <Route path="ai-vuln-discovery" element={<AIVulnDiscoveryPage />} />
          <Route path="exploitation-race" element={<ExploitationRacePage />} />
          <Route path="target-state" element={<TargetStatePage />} />
          <Route path="next-best-action" element={<NextBestActionPage />} />
          <Route path="exec-narrative" element={<ExecNarrativePage />} />
          <Route path="underwriting" element={<UnderwritingPage />} />
          <Route path="admin/underwriting-pricing" element={<AdminUnderwritingPricingPage />} />
          <Route path="countdowns" element={<CountdownBoardPage />} />
          <Route path="postmortems" element={<PostmortemsPage />} />
          <Route path="service-graph" element={<ServiceGraphPage />} />
          <Route path="decisions" element={<DecisionsPage />} />
          <Route path="diff" element={<WeeklyDiffPage />} />
          <Route path="m"    element={<Navigate to="/app/executive" replace />} />
          <Route path="time-machine" element={<TimeMachinePage />} />
          <Route path="leavers"        element={<LeaversPage />} />
          <Route path="sbom"           element={<SbomPage />} />
          <Route path="attack-matrix"  element={<AttackMatrixPage />} />
          <Route path="triage"         element={<VulnTriagePage />} />
          <Route path="status"         element={<StatusPagePublic />} />
          <Route path="brand"          element={<BrandMentionsPage />} />
          <Route path="sigma"          element={<SigmaRulesPage />} />
          <Route path="dns-posture"    element={<DnsPosturePage />} />
          <Route path="compliance-posture" element={<CompliancePosturePage />} />
          <Route path="dep-confusion"  element={<DepConfusionPage />} />
          <Route path="osv-feed"       element={<OsvFeedPage />} />
          <Route path="ip-reputation"  element={<IpReputationPage />} />
          <Route path="shodan-queries" element={<ShodanQueriesPage />} />
          <Route path="dora"           element={<DoraMetricsPage />} />
          <Route path="supply-chain-trust" element={<SupplyChainTrustPage />} />
          <Route path="detection-coverage" element={<DetectionCoveragePage />} />
          <Route path="purple-range" element={<PurpleRangePage />} />
          <Route path="atomic-red-team"    element={<AtomicRedTeamPage />} />
          <Route path="canarytokens"       element={<CanaryTokenPage />} />
          <Route path="nsm-lens"           element={<NsmLensPage />} />
          <Route path="misp-galaxy"        element={<MispGalaxyPage />} />
          <Route path="slos"               element={<SloPage />} />
          <Route path="chaos"              element={<ChaosPage />} />
          <Route path="drift"              element={<DriftPage />} />
          <Route path="policy"             element={<PolicyPage />} />
          <Route path="idp-risky"          element={<IdpRiskyPage />} />
          <Route path="secret-scans"       element={<SecretScansPage />} />
          <Route path="runbooks"           element={<RunbooksPage />} />
          <Route path="tabletops"          element={<TabletopPage />} />
          <Route path="bcp"                element={<BcpPage />} />
          <Route path="service-readmes"    element={<ServiceReadmePage />} />
          <Route path="data-residency"     element={<DataResidencyPage />} />
          <Route path="ransomware-geo"               element={<RansomwareGeoPage />} />
          <Route path="ransomware-geo/:country"      element={<RansomwareCountryDetailPage />} />
          <Route path="oncall"         element={<OnCallPage />} />
          <Route path="releases"       element={<GhReleasesPage />} />
          <Route path="ask"            element={<AskPage />} />
          <Route path="ci"             element={<CiStatusPage />} />
          <Route path="actor/:id"      element={<ActorDetailPage />} />
          <Route path="patch-tuesday"  element={<PatchTuesdayPage />} />
          <Route path="vendor-risk"    element={<VendorRiskPage />} />
          <Route path="credentials"    element={<CredentialExpiryPage />} />
          <Route path="bookmarks" element={<BookmarksPage />} />
          <Route path="notes" element={<NotesPage />} />
          <Route path="what-changed" element={<WhatChangedPage />} />
          <Route path="vendor-comparison" element={<VendorComparisonPage />} />
          <Route path="outage-history" element={<OutageHistoryPage />} />
          <Route path="top-stories" element={<TopStoriesPage />} />
          <Route path="compliance" element={<CompliancePage />} />
          <Route path="earnings" element={<EarningsCalendarPage />} />
          <Route path="sentiment-tracking" element={<SentimentTrackingPage />} />
          <Route path="cloud" element={<CloudPage />} />
          <Route path="innovation" element={<InnovationPage />} />
          <Route path="ai-radar" element={<InnovationPage />} />
          <Route path="emerging" element={<InnovationPage />} />
          <Route path="infra" element={<CloudPage />} />
          <Route path="ai-adoption" element={<AIAdoptionPage />} />
          <Route path="ai-risk-live" element={<AIRiskLivePage />} />
          <Route path="regulatory" element={<RegulatoryPage />} />
          <Route path="startups" element={<StartupsPage />} />
          <Route path="internet-health" element={<InternetHealthPage />} />
          <Route path="supply-chain" element={<SupplyChainPage />} />
          <Route path="opensource" element={<OpenSourcePage />} />
          <Route path="talent" element={<TalentPage />} />
          <Route path="hype-cycle" element={<HypeCyclePage />} />
          <Route path="briefing" element={<BriefingPage />} />
          <Route path="competitors" element={<CompetitorIntelPage />} />
          <Route path="manda" element={<MandAPage />} />
          <Route path="energy" element={<EnergyPage />} />
          <Route path="sentiment" element={<SentimentPage />} />
          <Route path="incidents" element={<IncidentPage />} />
          <Route path="globe-test" element={<GlobeTestPage />} />
          <Route path="terminal" element={<TerminalPage />} />
          <Route path="integrations" element={<IntegrationsPage />} />
          <Route path="workspace" element={<WorkspacePage />} />
          <Route
            path="world"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <WorldEventsPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
